import React, { useState } from "react";
import tickImg from "../../components/LandingPage/images/tickImg.png"; // Ensure the path is correct

const Subscription = () => {
  // State to toggle between monthly and annual billing
  const [isAnnual, setIsAnnual] = useState(false);

  // Function to bold numbers in the feature string
  const boldNumbers = (text) => {
    return (
      <span className="whitespace-wrap">
        {text
          .split(/(\d+|COMING SOON|3 custom folders|unlimited custom folders)/)
          .map((part, idx) => {
            if (part === "COMING SOON") {
              return (
                <span key={idx} className="text-[#A67FAA] font-bold">
                  {part}
                </span>
              );
            } else if (
              part === "3 custom folders" ||
              part === "unlimited custom folders"
            ) {
              return (
                <span key={idx} className="text-[#A67FAA] font-bold">
                  {part}
                </span>
              );
            } else if (/\d+/.test(part)) {
              return (
                <span key={idx} className="font-bold">
                  {part}
                </span>
              );
            }
            return part;
          })}
      </span>
    );
  };

  // Data for the subscription plans
  const plans = {
    monthly: [
      {
        title: "Basic",
        price: "$14.99/mo",
        badge: "Basic",
        features: [
          "40 Recipes per month",
          "150 Dish Searches per month",
          "10 Chat queries with Cook-E Chat Bot, Per Recipe",
          "Basic Cookbook Access up to 3 custom folders",
          "View, Engage with and Download Recipes from posts in the Chopping Block | COMING SOON",
        ],
      },
      {
        title: "Explorer",
        price: "$24.99/mo",
        badge: "Explorer",
        features: [
          "80 Recipes per month",
          "300 Dish Searches per month",
          "30 Chat queries with Cook-E Chat Bot, Per Recipe",
          "Full Cookbook Access unlimited custom folders",
          "View, Engage with and Download Recipes from posts in the Chopping Block | COMING SOON",
        ],
      },
      {
        title: "Foodie",
        price: "$34.99/mo",
        badge: "Foodie",
        features: [
          "150 Recipes per month",
          "600 Dish Searches per month",
          "50 Chat queries with Cook-E Chat Bot, Per Recipe",
          "Full Cookbook Access unlimited custom folders",
          "Post, View, Engage with and Download Recipes from posts in the Chopping Block | COMING SOON",
        ],
      },
    ],
    annual: [
      {
        title: "Basic",
        price: "$10.83/mo",
        badge: "Basic",
        features: [
          "40 Recipes per month",
          "150 Dish Searches per month",
          "10 Chat queries with Cook-E Chat Bot, Per Recipe",
          "Basic Cookbook Access up to 3 custom folders",
          "View, Engage with and Download Recipes from posts in the Chopping Block | COMING SOON",
        ],
      },
      {
        title: "Explorer",
        price: "$18.33/mo",
        badge: "Explorer",
        features: [
          "80 Recipes per month",
          "300 Dish Searches per month",
          "30 Chat queries with Cook-E Chat Bot, Per Recipe",
          "Full Cookbook Access unlimited custom folders",
          "View, Engage with and Download Recipes from posts in the Chopping Block | COMING SOON",
        ],
      },
      {
        title: "Foodie",
        price: "$25.67/mo",
        badge: "Foodie",
        features: [
          "150 Recipes per month",
          "600 Dish Searches per month",
          "50 Chat queries with Cook-E Chat Bot, Per Recipe",
          "Full Cookbook Access unlimited custom folders",
          "Post, View, Engage with and Download Recipes from posts in the Chopping Block | COMING SOON",
        ],
      },
    ],
  };

  return (
    <div className="flex flex-col items-center py-12 px-6">
      {/* Title */}
      <h1
        className="text-3xl md:text-5xl font-extrabold text-center text-[#A67FAA]"
        style={{ fontFamily: "Raleway, sans-serif" }}
      >
        Subscriptions
      </h1>

      {/* Billing Toggle */}
      <div className="flex justify-center items-center my-8 relative">
        <div className="relative">
          <button
            onClick={() => setIsAnnual(false)}
            className={`px-4 py-2 relative font-raleway ${
              !isAnnual ? "text-black font-bold" : "text-gray-500 font-bold"
            } text-lg`}
          >
            Billed Monthly
          </button>
          {!isAnnual && (
            <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-2 w-full flex items-center justify-center">
              <div className="h-1 w-full bg-[#A67FAA]" />
              <svg
                width="12"
                className="absolute bottom-[3px] left-[0px]"
                height="12"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon points="50,15 100,100 0,100" fill="#A67FAA" />
              </svg>

              <svg
                className="absolute bottom-[-10px] left-[0px]"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L6 12L12 0H0Z" fill="#A67FAA" />
              </svg>
            </div>
          )}
        </div>

        <span className="mx-4 text-[#A67FAA]">|</span>

        <div className="relative">
          <button
            onClick={() => setIsAnnual(true)}
            className={`px-4 py-2 relative font-raleway ${
              isAnnual ? "text-black font-bold" : "text-gray-500 font-bold"
            } text-lg`}
          >
            Billed Annually <span className="text-[#A67FAA]">(Save 20%)</span>
          </button>
          {isAnnual && (
            <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-2 w-full flex items-center justify-center">
              <div className="h-1 w-full bg-[#A67FAA]" />
              <svg
                width="12"
                className="absolute bottom-[3px] right-[-1px]"
                height="12"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon points="50,15 100,100 0,100" fill="#A67FAA" />
              </svg>
              <svg
                className="absolute bottom-[-10px] right-[-1px]"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L6 12L12 0H0Z" fill="#A67FAA" />
              </svg>
            </div>
          )}
        </div>
      </div>

      {/* Subscription Plans */}
      <div className="flex flex-col lg:flex-row justify-center items-center gap-6 max-w-6xl">
        {isAnnual
          ? plans.annual.map((plan, index) => (
              <div
                key={index}
                className={`relative flex flex-col justify-between bg-white shadow-lg rounded-lg p-6 w-full ${
                  index === 1
                    ? "lg:max-w-md lg:min-h-[550px] bg-opacity-100"
                    : "lg:max-w-sm lg:min-h-[450px] bg-opacity-70"
                } border-2 border-[#A67FAA]`}
              >
                <div>
                  <h2
                    className={`text-2xl font-raleway ${
                      index === 1 ? "font-bold" : ""
                    } text-black mb-2`}
                  >
                    {plan.price}
                  </h2>
                  <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-[#A67FAA] text-white text-sm font-bold">
                    {plan.badge}
                  </div>
                  <p className="text-black font-publicSans mb-4">
                    Ideal for individuals who want to explore and create the
                    recipes of the world.
                  </p>
                  <button className="mt-6 px-4 py-2 w-full font-raleway rounded-3xl bg-[#A67FAA] text-white font-extrabold hover:bg-[#9b69a2] transition-colors">
                    Upgrade to {plan.title}
                  </button>
                </div>
                <div className="pt-4">
                  <span className="text-xl font-semibold font-publicSans text-black">
                    What’s included?
                  </span>
                  <ul className="space-y-2 text-black pt-2">
                    {plan.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="text-black font-publicSans flex items-center"
                      >
                        <img
                          src={tickImg}
                          alt="Tick"
                          className="h-5 w-5 mr-2"
                        />
                        {boldNumbers(feature)}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))
          : plans.monthly.map((plan, index) => (
              <div
                key={index}
                className={`relative flex flex-col justify-between bg-white shadow-lg rounded-lg p-6 w-full ${
                  index === 1
                    ? "lg:max-w-md lg:min-h-[550px] bg-opacity-100"
                    : "lg:max-w-sm lg:min-h-[450px] bg-opacity-70"
                } border-2 border-[#A67FAA]`}
              >
                <div>
                  <h2
                    className={`text-2xl font-raleway ${
                      index === 1 ? "font-bold" : ""
                    } text-black mb-2`}
                  >
                    {plan.price}
                  </h2>
                  <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-[#A67FAA] text-white text-sm font-bold">
                    {plan.badge}
                  </div>
                  <p className="text-black font-publicSans mb-4">
                    Ideal for individuals who want to explore and create the
                    recipes of the world.
                  </p>
                  <button className="mt-6 px-4 py-2 w-full rounded-3xl bg-[#A67FAA] text-white font-raleway font-extrabold hover:bg-[#9b69a2] transition-colors">
                    Upgrade to {plan.title}
                  </button>
                </div>
                <div className="pt-4">
                  <span className="text-xl font-semibold font-publicSans text-black">
                    What’s included?
                  </span>
                  <ul className="space-y-2 text-black pt-2">
                    {plan.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="text-black font-publicSans flex items-center"
                      >
                        <img
                          src={tickImg}
                          alt="Tick"
                          className="h-5 w-5 mr-2"
                        />
                        {boldNumbers(feature)}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Subscription;
